var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-0 shadow-none",attrs:{"no-body":""}},[_c('b-card-body',_vm._l((_vm.assetsData),function(asset){return _c('div',{staticClass:"row justify-content-sm-between mt-0 border-bottom pt-2 pb-2"},[_c('AssetEntry',{attrs:{"asset":asset}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }